<nav class="bg-cover bg-no-repeat bg-center bg-bg-header w-full">
  <div class="bg-primary/60 flex items-center justify-between py-3 px-4">
    <div class="tix-header-branding flex items-center flex-1">
      <!-- Sidebar Toggle Button -->
      <button
        type="button"
        class="mr-6 flex items-center justify-center w-8 h-8 text-white hover:bg-white/10 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/20 lg:hidden"
        (click)="onToggleSidebar()"
        aria-label="Toggle sidebar"
      >
        <span class="material-icons-outlined">menu</span>
      </button>

      <div class="flex flex-col" *ngIf="userRolesInCompany$ | async as roles">
        <h4 *ngIf="isAdmin(roles)" class="text-white font-bold text-lg">
          {{ companyName$ | async }}
        </h4>
        <span
          [routerLink]="['/', 'company', (companyId$ | async) || 'add']"
          class="text-xs text-white/70 cursor-pointer hover:underline"
          >Edit Info</span
        >
      </div>
      <!-- <button
        matRipple
        cdkClickOutsideBehavior
        color="light"
        class="flex items-center space-x-1"
      >
        <span class="text-sm font-medium text-white/70">Recently Viewed</span>
        <mat-icon class="text-white/70">expand_more</mat-icon>
      </button> -->
    </div>
    <tix-profile-menu></tix-profile-menu>
  </div>
</nav>
